import React, { useRef, useState } from "react";
import "./spotlight-card.css";

/**
 * Подсветка «spotlight» за курсором (адаптация без Tailwind / Next).
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {string} [props.spotlightColor] — цвет в градиенте, например rgba(99,0,255,0.19)
 * @param {React.CSSProperties} [props.style]
 */
export default function SpotlightCard({
  children,
  className = "",
  spotlightColor = "rgba(99, 0, 255, 0.19)",
  style,
}) {
  const divRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e) => {
    if (!divRef.current || isFocused) return;
    const rect = divRef.current.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  const handleFocus = () => {
    setIsFocused(true);
    setOpacity(0.6);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setOpacity(0);
  };

  const handleMouseEnter = () => {
    setOpacity(0.6);
  };

  const handleMouseLeave = () => {
    setOpacity(0);
  };

  return (
    <div
      ref={divRef}
      tabIndex={0}
      onMouseMove={handleMouseMove}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`spotlight-card ${className}`.trim()}
      style={style}
    >
      <div
        className="spotlight-card__glow"
        style={{
          opacity,
          background: `radial-gradient(circle at ${position.x}px ${position.y}px, ${spotlightColor}, transparent 80%)`,
        }}
        aria-hidden
      />
      <div className="spotlight-card__inner">{children}</div>
    </div>
  );
}
